module.exports = __webpack_public_path__ + "img/kazakstan.39d962f6.svg";